import { createContext, useContext } from "react";

interface MobileShellContextValue {
  openChannelSheet: () => void;
  openDrawer?: () => void;
  openAgentSheet?: () => void;
}

export const MobileChannelContext = createContext<MobileShellContextValue | null>(null);

/** Returns an opener for the mobile channel picker, or null on desktop. */
export function useMobileChannelSheet(): MobileShellContextValue | null {
  return useContext(MobileChannelContext);
}

/** Returns the mobile-shell context for drawer / agent-sheet / channel-sheet access,
 *  or null when rendered outside the mobile shell (e.g. desktop). */
export function useMobileShell(): MobileShellContextValue | null {
  return useContext(MobileChannelContext);
}
